<style scoped>
h3 {
  /* font-size: 5em; */
  text-align: center;
  margin-top: 150px;
}
.container {
  padding-top: 64px;
  padding-bottom: 64px;
  height: 60vh;
}
</style>

<template lang="pug">
  .container.light-gray.text-center
    
    h3 
        small.text-muted.center &nbsp;&nbsp; Please wait for your account to be approved.
</template>
<script>
export default {
  meta: {
    title: 'Page not found'
  }
}
</script>


// WEBPACK FOOTER //
// src/components/page-reseller-notapprove.vue